import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'splitWordUppercase' })
export class SplitWordUppercasePipe implements PipeTransform {
  public transform(value: any): any {
    return value.match(/[A-Z][a-z]+|[0-9]+/g).join(' ');
  }
}
